// src/utils/auth.js

/**
 * Retrieves the authorization header with the JWT token from localStorage.
 * @returns {HeadersInit} An object containing the Authorization header, or an empty object if no token.
 */
export const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    if (token) {
        return { 'Authorization': `Bearer ${token}` };
    }
    return {};
};

/**
 * Handles user logout by clearing the token and user data from localStorage.
 * @returns {boolean} True if logout actions were performed.
 */
export const logout = () => {
    try {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('user_level');
        console.log('User logged out successfully.');
        return true;
    } catch (error) {
        console.error('Error during logout:', error);
        return false;
    }
};

/**
 * Helper function to parse user data from localStorage.
 * @returns {object|null} The parsed user object or null if not found.
 */
export const getUser = () => {
    try {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
        return null;
    }
};

/**
 * Checks whether the current user has a specific permission.
 * Reads from the permissions array stored in localStorage at login.
 *
 * Usage:
 *   import { hasPermission } from '../utils/auth';
 *   if (hasPermission('dashboard_full')) { ... }
 *
 * @param {string} permissionKey  e.g. 'dashboard_full', 'config_users'
 * @returns {boolean}
 */
export const hasPermission = (permissionKey) => {
    const user = getUser();
    if (!user || !Array.isArray(user.permissions)) return false;
    return user.permissions.includes(permissionKey);
};
